<template>
  <v-flex
    class="text-xs-center"
    xs12>
    <v-pagination
      v-if="pagesTotal > 1"
      :length="pagesTotal"
      :value="pageIndex"
      @input="val => pageIndex = val"/>
  </v-flex>
</template>

<script>
import PaginationApi from '@/api/PaginationApi'

export default {
  name: 'Pagination',
  props: ['url', 'query'],
  data () {
    return {
      pageIndex: 1,
      pagesTotal: 0,
      loading: true
    }
  },
  methods: {
    async getPaginatedData () {
      this.$emit('isLoading', true)
      try {
        const response = await PaginationApi.getPaginatedData(this.url, this.query, this.pageIndex)
        this.pagesTotal = response.last_page
        this.$emit('fetchedData', response.data)
      } catch (e) {
        this.$notification(e)
      }
      this.$emit('isLoading', false)
    }
  },
  watch: {
    pageIndex: {
      immediate: true,
      handler: 'getPaginatedData'
    },
    url: {
      handler: 'getPaginatedData'
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
